import { render, staticRenderFns } from "./LogoContainer.vue?vue&type=template&id=60f069e4&scoped=true&"
import script from "./LogoContainer.vue?vue&type=script&lang=js&"
export * from "./LogoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f069e4",
  null
  
)

export default component.exports